// Phase QCM follow-up — "Verified from FMCSA" badge guard.
//
// Returns true when the form field's current value matches the
// FMCSA-sourced value, so the badge disappears as soon as the user
// overrides the prefill and reappears if they restore it.
//
// Comparison rules:
//   - Both sides coerced to string and trimmed.
//   - Null/undefined/empty on EITHER side => false (no badge).
//   - Whitespace-only differences are ignored.
//
// Pure helper — extracted from FmcsaLookupCard purely so the tiny bit
// of equality logic can be unit-tested without rendering React.
export function isVerifiedFromFmcsa(formValue, fmcsaValue) {
    if (fmcsaValue === null || fmcsaValue === undefined) return false;
    if (formValue === null || formValue === undefined) return false;
    const a = String(formValue).trim();
    const b = String(fmcsaValue).trim();
    if (a === "" || b === "") return false;
    return a === b;
}

/**
 * Phase QCM-EXT — three-state classifier for review-mode pills.
 *
 * Returns:
 *   - "verified"  → form value matches the FMCSA value (green pill)
 *   - "diverged"  → FMCSA has a value AND the form value differs (amber chip)
 *   - "none"      → FMCSA has no value to compare against (render nothing)
 *
 * Reviewers see "verified" pills for fields that still match FMCSA,
 * "Customer-entered" chips for fields the customer/admin overrode, and
 * no badge at all for fields where FMCSA didn't supply data (so we
 * don't accuse a field of being edited when there's no reference value).
 */
export function classifyFmcsaField(formValue, fmcsaValue) {
    if (fmcsaValue === null || fmcsaValue === undefined) return "none";
    const b = String(fmcsaValue).trim();
    if (b === "") return "none";
    if (formValue === null || formValue === undefined) return "diverged";
    const a = String(formValue).trim();
    if (a === "") return "diverged";
    return a === b ? "verified" : "diverged";
}
